import {
  CLIENT_TOTAL_BOOKINGS,
  CLIENT_TOTAL_BOOKINGS_SUCCESS,
  CLIENT_TOTAL_BOOKINGS_ERROR,
  CLIENT_TOTAL_BOOKINGS_EMPTY,
} from '../../../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ClientTotalBookings = (state = initialState, action) => {
  switch (action.type) {
    case CLIENT_TOTAL_BOOKINGS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CLIENT_TOTAL_BOOKINGS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CLIENT_TOTAL_BOOKINGS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CLIENT_TOTAL_BOOKINGS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ClientTotalBookings;
